/**
 * Pure helpers behind the search box of the vanity item lists (frames, stickers, vinyls, badges,
 * emoji packs, posters). "Contains" match on the item ID and on its name, so both a partial UUID
 * copied from a gift or a log and a few letters of the name find the item.
 */

export type SearchableItem = { id: string; name?: string | null };

export const normalizeItemSearchTerm = (term: string): string => term.trim().toLowerCase();

export function matchesItemSearch(item: SearchableItem, normalizedTerm: string): boolean {
  if (!normalizedTerm) {
    return true;
  }
  return (
    item.id.toLowerCase().includes(normalizedTerm) || (item.name ?? '').toLowerCase().includes(normalizedTerm)
  );
}

export function filterItemsBySearch<T extends SearchableItem>(items: T[], term: string): T[] {
  const normalizedTerm = normalizeItemSearchTerm(term);
  if (!normalizedTerm) {
    return items;
  }
  return items.filter((item) => matchesItemSearch(item, normalizedTerm));
}
